export const manifest = {
  screens: {
    scr_login: { name: "Login Portal", route: "/login", position: {"x":-1240,"y":5780} },
    scr_llkvq6: { name: "Admin Dashboard", route: "/", position: {"x":160,"y":5780} },
    scr_j2obuh: { name: "Create Shipment", route: "/create", position: {"x":160,"y":1820} },
    scr_ntixzn: { name: "Appointments Calendar", route: "/appointments", position: {"x":160,"y":3800} },
    scr_2crvgb: { name: "Shipment Details (QR)", route: "/details", position: {"x":1560,"y":1820} },
    scr_l9tlmi: { name: "Capacity Settings", route: "/settings", position: {"x":4360,"y":1820} },
    scr_kanban: { name: "Shipments Kanban", route: "/kanban", position: {"x":2960,"y":1820} },
    scr_reports: { name: "Reports & Analytics", route: "/reports", position: {"x":1560,"y":5780} },
    scr_users: { name: "User Management", route: "/users", position: {"x":160,"y":7760} },
    scr_warehouses: { name: "Warehouse Settings", route: "/warehouses", position: {"x":160,"y":9740} },
    scr_approvals: { name: "Approval Queue", route: "/approvals", position: {"x":5760,"y":1820} },
    scr_capacity_mgmt: { name: "Capacity Management", route: "/capacity", position: {"x":7160,"y":1820} },
    scr_receiving: { name: "Check-in & Receiving", route: "/receiving", position: {"x":8560,"y":1820} },
    scr_notifications: { name: "Notifications", route: "/notifications", position: {"x":2960,"y":5780} },
    scr_user_details: { name: "User Details & RBAC", route: "/users/USR-002", position: {"x":1560,"y":7760} },
    scr_report_center: { name: "Report Center", route: "/reports", position: {"x":4360,"y":5780} },
    scr_system_settings: { name: "System Settings", route: "/system-settings", position: {"x":0,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_i9smhw: { name: "Shipment Management", x: 0, y: 1600, width: 9920, height: 1180 },
    sec_retxbo: { name: "Appointment Booking", x: 0, y: 3580, width: 1520, height: 1180 },
    sec_fb55if: { name: "Admin Dashboard", x: 0, y: 5560, width: 5720, height: 1180 },
    sec_1mfodj: { name: "User Management", x: 0, y: 7540, width: 2920, height: 1180 },
    sec_wehbe4: { name: "Warehouse Management", x: 0, y: 9520, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_i9smhw", children: [
      { kind: "screen", id: "scr_j2obuh" },
      { kind: "screen", id: "scr_2crvgb" },
      { kind: "screen", id: "scr_kanban" },
      { kind: "screen", id: "scr_l9tlmi" },
      { kind: "screen", id: "scr_approvals" },
      { kind: "screen", id: "scr_capacity_mgmt" },
      { kind: "screen", id: "scr_receiving" },
    ] },
    { kind: "section", id: "sec_retxbo", children: [
      { kind: "screen", id: "scr_ntixzn" },
    ] },
    { kind: "section", id: "sec_fb55if", children: [
      { kind: "screen", id: "scr_llkvq6" },
      { kind: "screen", id: "scr_reports" },
      { kind: "screen", id: "scr_notifications" },
      { kind: "screen", id: "scr_report_center" },
    ] },
    { kind: "section", id: "sec_1mfodj", children: [
      { kind: "screen", id: "scr_users" },
      { kind: "screen", id: "scr_user_details" },
    ] },
    { kind: "section", id: "sec_wehbe4", children: [
      { kind: "screen", id: "scr_warehouses" },
    ] },
    { kind: "screen", id: "scr_system_settings" },
  ],
}
